<template>
  <div class="home-about w-main">
    <div class="home-img">
      <el-image :src="img.about" fit="fill"></el-image>
    </div>
    <div class="home-box">
      <div class="home-box-title">上海市航海科技工作者自愿组成的地区性学会</div>
      <div class="home-box-text">
        上海市航海学会正式成立于1978年6月28日。41年来，学会发扬“励精图治，同舟奋进”精神，在组织建设、学术交流、决策咨询、科技评价、科学普及、编辑出版、专业培训、全国海洋船舶高职评申报服务、磁罗经校正等方面，取得丰硕成果，是上海市科学技术协会“四星级”学会，获评“中国社会组织4A等级”。
        作为政府部门联系航海界的桥梁和纽带，以及航海科技工作者的交流平台，学会会员网络基本覆盖上海国际航运中心，会员单位涉及上海地区的航运企业、海事机构、船员管理、科研院校、航道勘测、救助打捞、远洋渔业等。第十次会员代表大会后，拥有团体会员近50家。
      </div>
      <router-link to="/about" target="_blank" tag="a" class="home-button">
        <span>了解更多</span>
        <span>></span>
      </router-link>
    </div>
  </div>
</template>

<script>
import about from "@/assets/img/home/about.png";

export default {
  name: "pcHomeAbout",
  data() {
    return {
      img: {
        about
      }
    };
  }
};
</script>

<style lang="less">
.home-about {
  display: flex;
  justify-content: space-between;
  .home-img {
    width: 520px;
  }
  .home-box {
    width: calc(100% - 588px);
    &-title {
      height: 80px;
      line-height: 80px;
      font-size: 24px;
      font-weight: bold;
      color: rgba(33, 43, 53, 1);
    }
    &-text {
      margin-bottom: 56px;
      font-size: 18px;
      font-weight: 400;
      color: rgba(108, 111, 117, 1);
      line-height: 32px;
    }
  }
}
</style>
